import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { Dialog, DialogPanel, DialogBackdrop } from '@headlessui/react'

type Props = {
  open: boolean
  setOpen: (open: boolean) => void
  children: React.ReactNode
  className?: string
}

export function Modal({ open, setOpen, children, className }: Props) {
  return (
    <Dialog autoFocus={false} open={open} onClose={() => setOpen(false)} className='relative z-40'>
      <DialogBackdrop transition className='dialog-backdrop' />
      <div className='fixed inset-0 z-10 w-full overflow-y-auto'>
        <div className='flex min-h-full items-center justify-center p-6'>
          <DialogPanel className={twMerge('max-w-(--breakpoint-2xl) rounded-lg p-3 md:p-6 relative bg-white dark:bg-zinc-900 shadow-inner md:shadow-lg', className)}>
            {children}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
